import home from './home.vue';
import type { RouteComponent } from 'vue-router';

export default {
    home,
    logical_structure: () => import('./logical-structure/logical-structure.vue'),
    edit_menu: () => import('./menu/edit_menu.vue'),
    'sys-scope-org': () => import('./sys-scope-org/sys-scope-org.vue'),
    'all-users': () => import('./all-users/all-users.vue'),
    pg_reports_setup: () => import('./pg-reports-setup/pg-reports.vue'),

    // imported from Platform
    sys_metadata: () => import('@platform/layouts/system/metadata/sys_metadata.vue'),
    sys_metadata_field: () => import('@platform/layouts/system/metadata_field/sys_metadata_field.vue'),
    sys_doc_state_setting: () =>
        import('@platform/layouts/system/sys_doc_state_setting/sys_doc_state_setting_view.vue'),
    roles_setup: () => import('@platform/layouts/system/roles/roles-setup.vue'),
    events_listing: () => import('@managing/pages/events/events-listing.vue'),
    events_logs: () => import('@managing/pages/events/events-logs.vue'),
} as Record<string, RouteComponent | (() => Promise<RouteComponent>)>;
